module.exports = __webpack_public_path__ + "img/socio6.6afe5040.png";